import script from "./Main-Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Main-Dashboard.vue?vue&type=script&setup=true&lang=js"

import "./Main-Dashboard.vue?vue&type=style&index=0&id=5b0ee322&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0ee322"]])

export default __exports__